<template>
  <div id="com"
    v-loading="loading"
    element-loading-text="正在查询..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
  <div class="result-bj">

    </div>
  <div class="result-dh">
       <img src="../img/logo.png" alt="">
    </div>
    <div class="wsc-banner" style="background: url(&#39;https://static.westarcloud.com/5eb3d8e743e08600335b9f4d/images/m-banner-zwcx.jpg&#39;) no-repeat center top;background-size: cover;">
      <div class="container">
          <div class="banTit"> </div>
      </div>
    </div>
    <div class="wsc-layout">

    <div class="zw-block1">
        <div class="container">
            <div class="zgTit marktext" mark-txt="text_1">在线查询报告，服务质量安全放心</div>
            <div class="report1-result" style="">
                <div class="result-header clearfix">
                    <div class="result-tit left-block">您的 结果为：</div>
                </div>

                <div class="result-main">
                    <ul><li class="tit"><span>样品编号</span></li>
                      <li class="msg"><span>{{ report.samplesNumber }}</span></li>
                      <li class="tit"><span>报告编号</span></li>
                      <li class="msg"><span>{{ report.reportNumber }}</span></li>
                      <li class="tit"><span>委托单位</span></li>
                      <li class="msg"><span>{{ report.unit }}</span></li>
                      <li class="tit"><span>工程名称</span></li>
                      <li class="msg"><span>{{ report.projectName }}</span></li>
                      <li class="tit"><span>样品名称</span></li>
                      <li class="msg"><span>{{ report.samplesNmae }}</span></li>
                      <li class="tit"><span>型号规格</span></li>
                      <li class="msg"><span>{{ report.specification  }}</span></li>
                      <li class="tit"><span>委托日期</span></li>
                      <li class="msg"><span>{{ report.date }}</span></li>
                      <li class="tit"><span>判定依据</span></li>
                      <li class="msg"><span>{{ report.pdyj }}</span></li>
                      <li class="tit"><span>检测结论</span></li>
                      <li class="msg"><span>{{ report.jconclusion }}</span></li>
                      <li class="tit"><span>检测项目</span></li>
                      <li class="msg"><span>{{ report.jcxm }}</span></li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
   export default {
    data() {
      return {
        loading: true,
        labelPosition: 'right',
        report:''

      };
    },
    created(){
      document.title = " ";

    },
    methods: {

    },
    mounted(){

      // http://172.16.160.112:9999/#/scanQRCode/JCBG(01)156'
        var url = window.location.href; //要切割的链接
      // var url ='http://45.119.52.226:8090/api/report/JCBG(01)156'
        var index = url.lastIndexOf("\/");
        var str = url.substring(index+1,url.length);//参数
        var winhref = url.substring(0,index+1);//前端地址
        // console.log('请求地址http://45.119.52.226:8090/api/report/'+str);

        this.$axios.get('https://report.tyjc3935.com/api/report/'+str).then(res=>{
          if(res.data.code==0){
            this.report=res.data.report
            this.loading = false;
          }else{
          }

        })

		}


  }
    </script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
       /* html{
        font-size: calc(100vw / 10);
       } */
      /* #com{
        width: 7.5rem;
        font-size: 0.14rem;
      } */
       body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td, hr, button, article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    margin: 0rem;
    padding: 0rem;
}
    .wsc-banner {
      height: 5rem;
      text-align: center;
      margin-top: 0.2rem;
      /* border-radius: 0.2rem; */
    }
    .banTit {
      font-size: 0.7rem;
      line-height: 1rem;
      padding-top: 2rem;
      color: #ffffff;
      font-weight: bold;
    }
    .zw-block1 {
      font-size: 1.5rem;
    padding: 0.5rem 0.3rem 0.5rem;
}
.zgTit {
    color: #04152C;
    font-size: 0.5rem;
    line-height: 1rem;
    text-align: center;
}
.report1-result {
    margin-top: 1rem 1rem;
    /* padding: 0rem 0.5rem; */
}
.result-tit {
    margin: 0.6rem 0rem 0.5rem ;
    font-size: 0.4rem;
    line-height: 0.42rem;
    color: rgba(4,21,44,1);
}
.result-bj {
  width: 100%;
  height: 1.4rem;

}
.result-dh {
  z-index: 1;
  background-color: #fff;
  width: 100%;
  height: 1.4rem;
  position: fixed;
  top:0;
  display: flex;
  align-items: center;
}
.result-dh img {
  max-height: 100%;
  width: 3.8rem;
  margin-left: 0.2rem;
}
.result-main {
    margin-top: 0.3rem;
    width: 15rem;
    display: contents;
}

.result-main li {
    width: 100%;
    border-bottom: 0.02rem solid #fff;
    font-size: 0.4rem;
    color: #62748E;
    padding: 0.2rem 0.5rem;
    line-height: 0.6rem;
    box-sizing: border-box;
    list-style-type: none;
}
.result-main .tit {
    font-weight: bold;
    background: #F8F9FD;
    position: relative;
}
.result-main .msg {
    background: #E9F3F5;
}
  #com{
      /* display: inline-block; */
      width: 10rem;
    }

  /*
    ul{
      width: 500px;
      display: inline-block;
    }
    li{
      list-style-type:none;
    }
    .odd-row {
      background-color: #f2f2f2;
    }

    .even-row {
      background-color: #e6f7ff;
    } */

div{
  display: block;
}
    </style>



// WEBPACK FOOTER //
// src/views/report/ScanQRCode.vue